module.exports = __webpack_public_path__ + "static/media/Thumbs-up-selfie-image-in-app.ff077607.jpg";